module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Li4A7K/tc-custom/9781460343555.jpg?1728726326328",
      "alt": "This image is the cover for the book Magnate's Manifesto"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Magnate's Manifesto\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_c('b', [_vm._v("BILLIONAIRE PLAYBOY IGNITES INTERNATIONAL INCIDENT WITH HIS MANIFESTO ON WOMEN")])]), _c('i', [_c('b')]), _c('br'), _c('br'), _c('b', [_vm._v("Jared Stone:")]), _vm._v(" Visionary, rebel, the tech world's golden boyand now the most hated man on the planet! "), _c('br'), _c('br'), _c('b', [_vm._v("Bailey St. James:")]), _vm._v(" Survivor, powerful female executive, the only woman who refuses to bow down to Jared Stoneand the only woman who can save him? "), _c('br'), _c('br'), _vm._v("When Jared's manifesto makes him public enemy #1 the only way out is to make Bailey an offer she can't refusea very public promotion to VP! Now, with a major deal on the line and tensions rising, can it be long before Jared and Bailey move from spreadsheets to bed sheets?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennifer Hayward\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Award-winning author JENNIFER HAYWARD emerged on the publishing scene as the winner of Harlequin's So You Think You Can Write global writing contest. The recpient of Romantic Times Magazine's Reviewer's Choice Award for Best Harlequin Presents of 2014 Jennifer's careers in journalism and PR, including years of working alongside powerful, charismatic CEOs and traveling the world, have provided perfect fodder for the fast-paced, sexy stories she likes to write.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0